import { render } from "./PollItem.vue?vue&type=template&id=287f39e8"
import script from "./PollItem.vue?vue&type=script&lang=js"
export * from "./PollItem.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__